import Navbar from "../components/Navbar";
import BookingFooter from "../components/BookingFooter";

//import Footer from "../components/Footer";
import GallerySection from "../components/GallerySection";
import ExperienceSection from "../components/ExperienceSection";
import Parallax from "../components/Parallax";
import LifestyleGallery from "../components/LifestyleGallery";
import AmenitiesSection from "../components/AmenitiesSection";
import CTA from "../components/CTA";

console.log(CTA);

export default function Gallery() {
  return (
    <>
      <Navbar />

      <section
        style={{
          padding: "120px 32px 80px",
          background: "#F5F2EB",
          textAlign: "center",
        }}
      >
        <p
          style={{
            color: "#C9A66B",
            letterSpacing: ".18em",
            fontFamily: "'JetBrains Mono', monospace",
          }}
        >
          GALLERY
        </p>

        <h1
          style={{
            fontFamily: "'Fraunces', serif",
            fontSize: 56,
            color: "#222",
            marginTop: 18,
          }}
        >
          Discover Every Corner
        </h1>

        <p
          style={{
            maxWidth: 720,
            margin: "24px auto 0",
            lineHeight: 1.8,
            color: "#666",
            fontSize: 18,
          }}
        >
          Browse our serviced apartments, elegant interiors and thoughtfully
          designed spaces before your stay.
        </p>
      </section>

      <Parallax />

      <GallerySection />
              
      <ExperienceSection />

      <CTA />

      <LifestyleGallery />

      <AmenitiesSection />

      <BookingFooter />
    </>
  );
}